// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container_2izW5","circle":"Loader_circle_1ObyG","infiniteRotate":"Loader_infiniteRotate_2vo20"};